import { makeStyles } from '@material-ui/core';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const styles = makeStyles(theme => ({
    ctaContainer: {
        [theme.breakpoints.down('xs')]: {
            display: 'grid',
        },
    },
}));

export default styles;
